(() => {
  'use strict';

  const SELECTORS = {
    wrapper:       '#cart-upsell-wrapper',
    mainCard:      '#cart-upsell-main',
    secondaryCard: '#cart-upsell-secondary',
    addBtns:       '.cart-upsell-img-btn, .cart-upsell-add-btn',
    swatchBtns:    '.swatch-btn',
  };

  let eventsbound = false;

  // ── Helpers ───────────────────────────────────────────────────────────────

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function getSelectedVariantId(type) {
    const card = document.querySelector(`#cart-upsell-${type}`);
    if (!card) return null;

    const activeSwatch = card.querySelector('.swatch-btn.is-selected');
    if (activeSwatch) return activeSwatch.dataset.variantId;

    const select = card.querySelector('.cart-upsell-variant-select');
    if (select) return select.value;

    const hidden = card.querySelector('.cart-upsell-selected-variant');
    if (hidden) return hidden.value;

    return null;
  }

  // ── Core display logic ────────────────────────────────────────────────────

  async function evaluateUpsell() {
    const wrapper = document.querySelector(SELECTORS.wrapper);
    if (!wrapper) return;

    const mainProductId      = parseInt(wrapper.dataset.mainProductId, 10);
    const secondaryProductId = parseInt(wrapper.dataset.secondaryProductId, 10);

    const cart      = await fetchCart();
    const cartItems = cart.items || [];

    const hasMain      = cartItems.some(i => i.product_id === mainProductId);
    const hasSecondary = cartItems.some(i => i.product_id === secondaryProductId);

    const mainCard      = document.querySelector(SELECTORS.mainCard);
    const secondaryCard = document.querySelector(SELECTORS.secondaryCard);

    if (mainCard)      mainCard.style.display      = 'none';
    if (secondaryCard) secondaryCard.style.display = 'none';

    if (!hasMain && mainCard) {
      mainCard.style.display = 'block';
    } else if (!hasSecondary && secondaryCard) {
      secondaryCard.style.display = 'block';
    }
  }

  // ── Add to cart ───────────────────────────────────────────────────────────

  async function addUpsellToCart(variantId) {
    const res = await fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 }),
    });

    if (!res.ok) {
      const err = await res.json();
      console.error('[CartUpsell] Add failed:', err);
      return false;
    }
    return true;
  }

  // ── Event listeners — bound once at document level ────────────────────────

  function bindEvents() {
    if (eventsbound) return;
    eventsbound = true;

    // Add to cart — delegated so it works after DOM replacement
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest(SELECTORS.addBtns);
      if (!btn) return;

      const type      = btn.dataset.upsellType;
      const variantId = getSelectedVariantId(type);
      if (!variantId) return;

      btn.disabled    = true;
      btn.textContent = '...';

      const success = await addUpsellToCart(variantId);

      if (success) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell' });
        await evaluateUpsell();
      } else {
        btn.disabled    = false;
        btn.textContent = '+ ADD';
      }
    });

    // Color swatch selection — delegated
    document.addEventListener('click', (e) => {
      const swatch = e.target.closest(SELECTORS.swatchBtns);
      if (!swatch) return;
      const group = swatch.closest('.cart-upsell-swatches');
      group.querySelectorAll('.swatch-btn').forEach(s => s.classList.remove('is-selected'));
      swatch.classList.add('is-selected');
    });

    // Subscribe to Dawn's pub/sub — re-evaluates on every cart mutation
    // AND handles the case where the wrapper was just injected into the DOM
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-upsell') return;
      // Small delay to allow Dawn to finish re-rendering the drawer HTML
      setTimeout(evaluateUpsell, 150);
    });
  }

  // ── MutationObserver — watches for wrapper being injected ─────────────────

  function observeForWrapper() {
    const observer = new MutationObserver(() => {
      if (document.querySelector(SELECTORS.wrapper)) {
        evaluateUpsell();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree:   true,
    });
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  function init() {
    bindEvents();        // always bind at document level — safe to call early
    observeForWrapper(); // watch for wrapper injection after cart becomes non-empty
    evaluateUpsell();    // run immediately if wrapper already exists on load
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
